import Vue from 'vue'
import i18n from './assets/i18n/i18n.js'
import { store } from './store/store'
import { ValidationObserver,ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import * as rules from 'vee-validate/dist/rules';
import { DropdownAccountMappingsAlvFields } from './assets/dropdowns/alvDropdowns.js'
import { validate as validateBankDataLocalized, ERR_INVALID_COUNTRY, ERR_TOKEN_COUNT, supportedCountries } from './utils/bankDataLocalizedSchema.js'

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
  });

// computesRequired attribute => https://logaretm.github.io/vee-validate/guide/required-fields.html#creating-a-required-rule

extend('required', { 
    ...required,
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_MESSAGE_FIELD_REQUIRED", values)
})

extend('ipiLength', {
    validate(value) { return value.toString().length == 11 },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_IPI_LENGTH", values),
    computesRequired: true
})

extend('passwordLength', {
    validate(value) { return value.toString().length >= 8 },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_PASSWORD_LENGTH", values),
    computesRequired: true
})

extend('alvDropdownRequired', {
    validate(value) { return value !== "" },
    computesRequired: true
})

extend('notZero', {
    validate(value) { return value !== "0" },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_NOT_ZERO", values),
    computesRequired: true
})

extend('empty', {   // can be empty
    validate(value) { return value === '' || value !== '' },
    computesRequired: true
})

extend('rangeinteger_1-9999', { // positive integers within a range
    validate(value) {
        if(isNaN(value)) return false
        else {
            var val = parseInt(value)
            if(val >= 1 && val <= 9999) return true
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_POSITIVE_INTEGER_BETWEEN", values) 
})

extend('positiveinteger', { // positive integers without zero
    validate(value) {
        if(isNaN(value)) return false
        else {
            if(/^(?:[1-9]\d*)$/.test(String(value))) {
                return true;
            }
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_POSITIVE_INTEGER_BIGGER_ONE", values) 
})

extend('integer', { // positive integers with zero
    validate(value) {
        if(isNaN(value)) return false
        else {
            if(/^(?:[1-9]\d*|0)$/.test(String(value))) return true
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_POSITIVE_INTEGER", values) 
})

extend('integerMinMax', {
    validate(value, { min, max }) {
        if(isNaN(value)) return false
        else {
            if(/^(?:[1-9]\d*|0)$/.test(String(value))) {
                if(parseInt(value) >= parseInt(min) && parseInt(value) <= parseInt(max)) {
                    return true
                }
            } else {
                return false
            }
        }
    },
    params: ['min', 'max'],
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_POSITIVE_INTEGER_MIN_MAX", values)
  });

extend('freeRoleSplitMusic', {
    validate(value) {
        if (value >= "35.2" && value <= "80.2") return true
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_FREE_ROLESPLIT_MUSIC", values)

})

extend('percentDecimal3', { // float numbers between 0 and 100 with MAX 3 decimals (comma or period; locale format is applied on blur)
    validate(value) {
        const normalized = String(value).trim().replace(',', '.')
        if (!/^[+]?(?:\d{1,2}(?:\.\d{1,3})?|100(?:\.0{1,3})?)$/.test(normalized)) return false
        const num = parseFloat(normalized)
        return num >= 0 && num <= 100
    },
    message: (_, values) => i18n.t("lang_ERROR_AZ_WITHHOLDING_TAX_PERCENTAGE_WRONG_FORMAT", values)
})

extend('percentDecimal', { // float numbers between 0 and 100 with MAX 2 decimals (with comma or period)
    validate(value) {
        // let numberFormat = store.getters.getUser.numberFormat
        if(i18n.locale === 'de') {
            // if(/^[-+]?[0-9]+(\,[0-9]+$)?$/.test(String(value))) {
            //     let tempVal = value.replace(/,/g, ".")
            //     if(tempVal >= 0 && tempVal <= 100) return true
            //  }
            if(/^[+]?((([0-9]|[1-9][0-9])(\,\d{1,2})?)|(100(\,[0]{1,2})?))$/.test(String(value))) return true
        } else {
            // if(/^[-+]?[0-9]+(\.[0-9]+$)?$/.test(String(value))) {
            //     if(value >= 0 && value <= 100) return true
            // }
            if(/^[+]?((([0-9]|[1-9][0-9])(\.\d{1,2})?)|(100(\.[0]{1,2})?))$/.test(String(value))) return true
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_PERCENT_DECIMAL_100", values) 
})

extend('wuf', {
    validate(value) {
        if(i18n.locale === 'de') {
            if(/^[-+]?[0-9]+(\,[0-9]+$)?$/.test(String(value))) {
                value.toString()
                let tempVal = value.replace(/,/g, ".")
                if(tempVal >= 0 && tempVal <= 50000) return true
             }
        } else {
            if(/^[-+]?[0-9]+(\.[0-9]+$)?$/.test(String(value))) {
                if(value >= 0 && value <= 50000) return true
            }
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_WUF", values) 
})

extend('isrc', {
    validate(value) {
        if(/[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}/.test(String(value))) return true
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_ISRC", values)
})

extend('iswc', {
    validate(value) {
        if(/^T-?\d{3}.?\d{3}.?\d{3}-?\d{1}|T-?\d{10}/.test(String(value))) return true
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_ISWC", values)
})

extend('duration', {
    validate(value) {
        if(/(?:[01]\d|2[0123]):(?:[012345]\d):(?:[012345]\d)|^(?:[012345]\d|2[0-9]):(?:[012345]\d|2[0-9])$/.test(String(value))) return true
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_DURATION", values)
})

extend('listTwoCharacterWordsWithCommas', {
    validate(value) {
        if(/^[a-zA-Z]{2}(,[a-zA-Z]{2})*$/.test(String(value)))
            return true
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_TWO_CHARS_WITH_COMMAS", values)
})

extend('amountMaxTwoDigits', {
    validate(value) {
        if(i18n.locale === 'de') {
            value = value.replace('.', '')
            if(/^(\d+(?:[\,]\d{1,2})?)$/.test(String(value))) return true
        }
        else {
            value = value.replace(',', '')
            if(/^(\d+(?:[\.]\d{1,2})?)$/.test(String(value))) return true
        }
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_AMOUNT_MAX_TWO_DIGITS", values)
})
extend('positiveOrNegativeWithMaxFourDigits', {
    validate(value) {
        // allowing negative values
        value = value.replace('-', '')
        
        // Check if it is a round number
        if (Number(value) % 1 === 0) {
            return true
        }

        const isGermanLang = i18n.locale === 'de'
        if (!isGermanLang) {
            // check if it is decimal number with max 4 decimals
            // e.g. (2000.2222)
            const decimalPattern = /^\d+(\.\d{1,4})?$/;
            if (decimalPattern.test(value)) {
                return true
            }

            // check if it is comma thousand separator as a whole number or
            // comma thousand separator as a decimal number with max 4 decimals
            // e.g. (2,000.2222)
            var engRegex = /^(\d{1,3}(,\d{3})*|\d+)(\.\d{1,4})?$/;
            if (engRegex.test(value)) {
                return true
            }
        } else { // german language
            // check if it is decimal number with max 4 decimals
            // e.g. (2000,2222)
            var decimalPattern = /^\d+(,\d{1,4})?$/;
            if (decimalPattern.test(value)) {
                return true
            }

            // check if it is dot thousand separator as a whole number or
            // dot thousand separator as a decimal number with max 4 decimals
            // e.g. (2.000,2222)
            var engRegex = /^(\d{1,3}(\.\d{3})*|\d+)(,\d{1,4})?$/

            if (engRegex.test(value)) {
                return true
            }
        }
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_AMOUNT_MAX_FOUR_DIGITS", values)
})
extend('positiveOrNegativeWithMaxTwoDigits', {
    validate(value) {
        if (value === null || value === undefined || value === '') {
            return true
        }
        // allowing negative values
        value = value.replace('-', '')
        
        // Check if it is a round number
        if (Number(value) % 1 === 0) {
            return true
        }

        const isGermanLang = i18n.locale === 'de'
        if (!isGermanLang) {
            // check if it is decimal number with max 2 decimals
            // e.g. (2000.22)
            const decimalPattern = /^\d+(\.\d{1,2})?$/;
            if (decimalPattern.test(value)) {
                return true
            }

            // check if it is comma thousand separator as a whole number or
            // comma thousand separator as a decimal number with max 2 decimals
            // e.g. (2,000.22)
            var engRegex = /^(\d{1,3}(,\d{3})*|\d+)(\.\d{1,2})?$/;
            if (engRegex.test(value)) {
                return true
            }
        } else { // german language
            // check if it is decimal number with max 2 decimals
            // e.g. (2000,22)
            var decimalPattern = /^\d+(,\d{1,2})?$/;
            if (decimalPattern.test(value)) {
                return true
            }

            // check if it is dot thousand separator as a whole number or
            // dot thousand separator as a decimal number with max 2 decimals
            // e.g. (2.000,22)
            var engRegex = /^(\d{1,3}(\.\d{3})*|\d+)(,\d{1,2})?$/

            if (engRegex.test(value)) {
                return true
            }
        }
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_AMOUNT_MAX_TWO_DIGITS", values)
})

extend('amountMaxEightDigits', {
    validate(value) {
        if(/^(\d+(?:[\.\,]\d{1,8})?)$/.test(String(value)))
        // if(/^(\d+(?:[\.\,]\d{1,2})?)$/.test(String(value)))
            return true
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_AMOUNT_MAX_EIGHT_DIGITS", values)
})

extend('amount', { 
    validate(value) {
        // allowing negative values
        value = value.toString().replace('-', '')

        // Check if it is a round number
        if (Number(value) % 1 === 0) {
            return true
        }

        const isGermanLang = i18n.locale === 'de'
        if (!isGermanLang) {
            // check if it is comma thousand separator as a whole number or
            // comma thousand separator as a decimal
            var engRegex = /^(\d{1,3}(,\d{3})*|\d+)(\.\d{1,15})?$/;
            if (engRegex.test(value)) {
                return true
            }
        } else { // german language
            // check if it is dot thousand separator as a whole number or
            // dot thousand separator as a decimal number
            var engRegex = /^(\d{1,3}(\.\d{3})*|\d+)(,\d{1,15})?$/

            if (engRegex.test(value)) {
                return true
            }
        }
    },
    // message: (_,values) => i18n.t("", values)
})

// SHEETS
extend('sheetProductionYearBetween', {
    validate(value) { return value >= 1800 },
    message: (_, values) => i18n.t("lang_PUBLISHING_SHEETS_VALIDATION_FIRST_PRODUCTION_YEAR_BETWEEN", values) 
})

extend('sheetValidProductionYear', {
    validate(value) {
        let firstBroadcastDate = store.getters.getSheetDetailsFirstBroadcastDate
        if(firstBroadcastDate !== null) return value <= firstBroadcastDate.substring(0,4)
        
        return true
    },
    message: (_, values) => i18n.t("lang_PUBLISHING_SHEETS_VALIDATION_FIRST_PRODUCTION_YEAR_BEFORE", values) 
})


extend('statisticsCheckToFromMonthOrder', {
    validate(value) {
        let fromMonth = store.getters.getSelectedLabelStatisticsFrom
        let toMonth = store.getters.getSelectedLabelStatisticsTo

        if(toMonth !== null && fromMonth !== null)  {            
            let fromMonthArray = fromMonth.split("-");
            let fromMonthDate = new Date(fromMonthArray[0], fromMonthArray[1])
            
            let toMonthArray = toMonth.split("-");
            let toMonthDate = new Date(toMonthArray[0], toMonthArray[1])

            let isFromBeforeTo = fromMonthDate <= toMonthDate ? true : false
            return isFromBeforeTo
        } else return true
    },
    message: (_, values) => i18n.t("lang_LABEL_STATISTICS_MONTH_PICKER_VALIDATION", values) 
})

extend('publishingStatisticsCheckToFromMonthOrder', {
    validate(value) {
        let fromMonth = store.getters.getSelectedPublishingStatisticsFrom
        let toMonth = store.getters.getSelectedPublishingStatisticsTo

        if (toMonth !== null && fromMonth !== null) {
            let fromMonthArray = fromMonth.split("-")
            let fromMonthDate = new Date(fromMonthArray[0], fromMonthArray[1])

            let toMonthArray = toMonth.split("-")
            let toMonthDate = new Date(toMonthArray[0], toMonthArray[1])

            return fromMonthDate <= toMonthDate
        }
        return true
    },
    message: (_, values) => i18n.t("lang_LABEL_STATISTICS_MONTH_PICKER_VALIDATION", values)
})

extend('labelStatementsCheckToFromMonthOrder', {
    validate(value) {
        let fromMonth = store.getters.getSelectedLabelStatementsLicensorPaymentsFromMonth
        let toMonth = store.getters.getSelectedLabelStatementsLicensorPaymentsToMonth

        if(toMonth !== null && fromMonth !== null)  {            
            let fromMonthArray = fromMonth.split("-");
            let fromMonthDate = new Date(fromMonthArray[0], fromMonthArray[1])
            
            let toMonthArray = toMonth.split("-");
            let toMonthDate = new Date(toMonthArray[0], toMonthArray[1])

            let isFromBeforeTo = fromMonthDate <= toMonthDate ? true : false


            return isFromBeforeTo
        } else 
        {
            return true
        }
    },
    message: (_, values) => i18n.t("lang_LABEL_STATISTICS_MONTH_PICKER_VALIDATION", values) 
})

extend('timeHoursMinutes', {
    validate(value) {
        if(/^(?:\d|[01]\d|2[0-3]):[0-5]\d$/.test(String(value)))
            return true
    },
    message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_TIME_HH_MM", values)
})
// extend('durationHoursMinutesSeconds', {
//     validate(value) {
//         if(/^\d+:\d{2}:\d{2}$/.test(String(value)))
//             return true
//         else if(/^\d{2}:\d{2}$/.test(String(value)))
//             return true
//     },
//     message: (_, values) => i18n.t("lang_GENERIC_VALIDATION_TIME_HH_MM", values)
// })

// LABEL CONTRACTS
extend('balanceNotGreaterThanZero', {
    validate(value) { 
        let advance = store.getters.getLabelContractsAdvance
        if(advance.length === 0) {
            if(Vue.prototype.$alvPlugin.stringToFloat(value) <= 0) return true
            else return false
        } else {
            let lastBalance = store.getters.getLabelContractsAdvance[0].balance
            let selectedId = store.getters.getSelectedLabelContractsAdvance
            if(selectedId && !Array.isArray(selectedId)) {
                let selectedItem = advance.find(item => item.id === selectedId)
                if(selectedItem) {
                    lastBalance -= selectedItem.credit
                }
            }
            return lastBalance + Vue.prototype.$alvPlugin.stringToFloat(value) <= 0
        }
    }, 
    message: (_, values) => i18n.t("lang_CONTRACTS_LABEL_ADVANCE_PANEL_VALIDATION_CREDIT_TOO_HIGH", values)
}) 

// PUBLISHING CONTRACTS
extend('publishingBalanceNotGreaterThanZero', {
    validate(value) { 
        let advance = store.getters.getPublishingContractsAdvance
        if(advance.length === 0) {
            return Vue.prototype.$alvPlugin.stringToFloat(value) <= 0
        }
        let lastBalance = advance[0].balance
        if(lastBalance === null || lastBalance === undefined || isNaN(lastBalance)) {
            return true
        }
        let selectedId = store.getters.getSelectedPublishingContractsAdvance
        if(selectedId && !Array.isArray(selectedId)) {
            let selectedItem = advance.find(item => item.id === selectedId)
            if(selectedItem) {
                lastBalance -= selectedItem.amount
            }
        }
        return lastBalance + Vue.prototype.$alvPlugin.stringToFloat(value) <= 0
    }, 
    message: (_, values) => i18n.t("lang_CONTRACTS_LABEL_ADVANCE_PANEL_VALIDATION_CREDIT_TOO_HIGH", values)
}) 

// TRACKING
extend('prolistYear', {
    validate(value) { return (value <= new Date().getFullYear() && value >= 2008 && value !== "") },
    computesRequired: true
})

extend('percent3Decimals', { // float numbers between 0 and 100 with MAX 3 decimals (with comma or period)
    validate(value) {
        // let numberFormat = store.getters.getUser.numberFormat
        if(i18n.locale === 'de') {
            // if(/^[-+]?[0-9]+(\,[0-9]+$)?$/.test(String(value))) {
            //     let tempVal = value.replace(/,/g, ".")
            //     if(tempVal >= 0 && tempVal <= 100) return true
            //  }
            if(/^[+]?((([0-9]|[1-9][0-9])(\,\d{1,3})?)|(100(\,[0]{1,2})?))$/.test(String(value))) return true
        } else {
            // if(/^[-+]?[0-9]+(\.[0-9]+$)?$/.test(String(value))) {
            //     if(value >= 0 && value <= 100) return true
            // }
            if(/^[+]?((([0-9]|[1-9][0-9])(\.\d{1,3})?)|(100(\.[0]{1,2})?))$/.test(String(value))) return true
        }
    },
    message: (_, values) => i18n.t("lang_GENERAL_VALIDATION_PERCENT_THREE_DECIMALS_100", values) 
})

// Persons Panel
extend('personDoesntAlreadyExists', {
    validate(selectedPerson) {
        let addedPersons = store.getters.getPersonsPanelEntry
        const even = (element) => element % 2 === 0;
        let personExists = addedPersons.some((existingPerson) => existingPerson.id === selectedPerson.id)
        return !personExists
    },
    message: (_, values) => i18n.t("lang_AZ_PERSONS_VALIDATION_PERSON_ALREADY_ADDED", values) 
})

function isStatisticsFavoriteNameTaken(dropdownValues, favoriteName) {
    const name = String(favoriteName == null ? '' : favoriteName).trim()
    if (!name) return false
    return (dropdownValues || []).some((item) => {
        if (!item || item.divider) return false
        if (item.value === 'newFavorite' || item.value === 'deleteFavorite') return false
        if (item.text == null || item.text === '') return false
        if (String(item.text).startsWith('lang_')) return false
        return String(item.text).trim() === name
    })
}

extend('statisticsFavoriteNameUnique', {
    params: ['getter'],
    validate(value, { getter }) {
        return !isStatisticsFavoriteNameTaken(store.getters[getter], value)
    },
    message: (_, values) => i18n.t('lang_GENERAL_STATISTICS_VALIDATION_FAVORITE_NAME_EXISTS', values),
})

extend('isTrackArtistObject', {
    validate(value) {
        let selectedArtist = store.getters.getTrackDetailsArtist
        if(typeof selectedArtist === 'object') return true
        else return false
    },
    message: (_, values) => i18n.t("lang_GENERIC_AZ_VALIDATION_ARTIST_IS_NOT_AZ_ENTITY", values) 
})

extend('isReleaseArtistObject', {
    validate(value) {
        let selectedArtist = store.getters.getLabelReleasesDetailsArtist
        if(typeof selectedArtist === 'object') return true
        else return false
    },
    message: (_, values) => i18n.t("lang_GENERIC_AZ_VALIDATION_ARTIST_IS_NOT_AZ_ENTITY", values) 
})

// Works registration 

extend('workRegistrationCheckboxes', {
    validate(value) {
        return value.includes("signedPublishingContract") && value.includes("registrationTruthfulComplete") ? true : false
    },
    computesRequired: true
})

extend('numericStringWithOptionalLeadingZeroAndLength9to11', {
    validate(value) {
        // only numbers
        // allowing leading zeros
        // minimum 9 digits
        // maximum 11 digits
        if(/^[0-9]{9,11}$/.test(String(value))) return true
    },
    message: (_, values) => i18n.t("lang_PUBLISHING_GENERIC_TOOLTIP_IPI_FORMATTING", values),
    computesRequired: true
})

extend('noLeadingZeroNumericString', {
    // only numbers
    // do not allow leading zeros
    validate(value) {
        if(/^[1-9][0-9]*$/.test(String(value))) return true
    },
    message: (_, values) => i18n.t("lang_PUBLISHING_GENERIC_TOOLTIP_KTO_FORMATTING", values),
    computesRequired: true
})

extend('workRegistrationCwrSubmitterCode', {
    // Allow only if selected CWR submitter has CWR submitter code set
    validate(value) {
        let parts = value.split("#")
        if (parts.length == 1 || parts[0].length !== 3) {
            return false
        }
        return true
    },
    message: (_, values) => i18n.t('lang_PUBLISHING_CONTRACTS_EXPORT_CWR_NOCODE', values),
    computesRequired: true
})

// extend('workRegistrationCheckboxes', {
//     validate(value) {
//         return value.includes("signedPublishingContract") ? true : false
//     }
// })


extend('validateMappingsFormula', {
    validate(value) {
        let isNocol = store.getters.getColumnMappingsDetailsTemplateColumn === 'NOCOL'
        // First check individually these formulas (Case 1, 3, 4, 5)
        // Case 1: Plain text input in double quotes
        const plainTextRegex = /^"[^"]+"$/;

        // Case 3: NOT Equal with NOT("...")
        const notRegex = /^"[^"]*"=NOT\("[^"]*"\)(,"[^"]*"=NOT\("[^"]*"\))*$/;

        // Case 4: IF Equal with list in parentheses
        const ifRegex = /^"[^"]*"=\("[^"]*"(?:,"[^"]*")*\)(,"[^"]*"=\("[^"]*"(?:,"[^"]*")*\))*$/;

        // Case 5: Concat
        const concatRegex = /^>?("[^"]+"(>"[^"]+")*)$/

        // Check case 2, 6, 7 by splitting formula with comma, then validate with its regex
        // Case 2: colon separated 
        const colonSeparatedRegex = /^("([^"]+)":"([^"]+)"(,"([^"]+)":"([^"]+)")*)$/;

        // Case 6: Negative
        const negativeRegex = /^Negative:\s*([a-zA-Z_]+\s*=>)?\s*"(src:)?[^"]+"$/

        // Case 7: Default and empty
        const defaultRegex = /^Default:\s*([a-zA-Z_]+\s*=>)?\s*"(src:)?[^"]+"$/
        const emptyRegex = /^Empty:\s*([a-zA-Z_]+\s*=>)?\s*"(src:)?[^"]+"$/

        // Case 8: Replace formula
        const replaceRegex = /Replace\("([^"\\\\]*(?:\\\\.[^"\\\\]*)*)":"([^"\\\\]*(?:\\\\.[^"\\\\]*)*)"\)/

        // Case 9: skipRow formula
        const skipRowRegex = /^skipRow\("[^"]+"(?:,"[^"]+")*\)$/

        // Case 11: Extract formula, regex of a shortcut field. Only the syntax is checked here, as PHP (backend) and JS regexes differ
        const extractRegex = /^Extract\("(?:[^"\\]|\\.)+"\)$/

        // Case 10: Division — operand/operand where each operand is alvField or "src:column"
        const divisionRegex = /^(?:[a-zA-Z_]+|"src:[^"]+")\/(?:[a-zA-Z_]+|"src:[^"]+")$/

        const direction = store.getters.getMappingsDetailsDirection
        const entityName = store.getters.getColumnMappingsDetailsEntityName
        const alvFieldList = (direction && entityName) ? DropdownAccountMappingsAlvFields[direction + "_" + entityName] || [] : []
        const validAlvFieldValues = new Set(alvFieldList.map(f => f.value))

        function isValidDivision(str) {
            if (!divisionRegex.test(str)) return false
            const parts = str.split('/')
            for (const part of parts) {
                if (part.startsWith('"src:')) continue
                if (!validAlvFieldValues.has(part)) return false
            }
            return true
        }

        let plainTextResult = plainTextRegex.test(value)
        let notResult = notRegex.test(value)
        let ifResult = ifRegex.test(value)
        let concatResult = concatRegex.test(value)
        let skipRowResult = skipRowRegex.test(value)
        let extractResult = extractRegex.test(value)
        let divisionResult = isValidDivision(value)
        let firstRoundValidation = value.trim() == '' || plainTextResult || notResult || ifResult || concatResult || skipRowResult || extractResult || divisionResult

        if (!firstRoundValidation) {
            const tokens = value.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/)

            let emptyCount = 0;
            let defaultCount = 0;
            let negativeCount = 0;
            for (let token of tokens) {
                token = token.trim()
                if (token.startsWith('skipRow')) {
                    if (!skipRowRegex.test(token)) {
                        return false
                    }
                    continue
                }

                if (token.startsWith('Extract')) {
                    if (!extractRegex.test(token)) {
                        return false
                    }
                    continue
                }

                if (divisionRegex.test(token)) {
                    if (!isValidDivision(token)) return false
                    continue
                }

                let negativeResult = negativeRegex.test(token)
                let colonResult = colonSeparatedRegex.test(token)
                let defaultResult = defaultRegex.test(token)
                let emptyResult = emptyRegex.test(token)
                let replaceResult = replaceRegex.test(token)

                negativeCount += negativeResult ? 1 : 0
                defaultCount += defaultResult ? 1 : 0
                emptyCount += emptyResult ? 1 : 0 

                // Empty and default are not allowed to appear more than once
                // Empty is not allowed at all if NOCOL is selected
                if (!(negativeResult || colonResult || emptyResult || defaultResult || replaceResult) || emptyCount > (isNocol ? 0 : 1) || defaultCount > 1 || negativeCount > 1) {
                    return false
                }
            }

            return true
        }
        
        return firstRoundValidation || colonResult || negativeResult || defaultEmptyResult
    },
    message: (_, values) => i18n.t("lang_MESSAGE_ERROR_MAPPING_FORMULA_VALIDATION", values)
})



// Localized bank data (A-Z > Finance, ALVCODE-1259 Stufe 2). Country-schema based
// pipe string. Optional field, so empty values pass (rule only runs on non-empty).
extend('bankDataLocalized', {
    validate(value) {
        const result = validateBankDataLocalized(value)
        return result.valid
    },
    message: (_, values) => {
        const result = validateBankDataLocalized(values._value_)
        if (result.error === ERR_INVALID_COUNTRY) {
            return i18n.t('lang_GENERIC_MESSAGE_ERROR_BANK_DATA_INVALID_COUNTRY', { countries: supportedCountries().join(', ') })
        }
        if (result.error === ERR_TOKEN_COUNT) {
            return i18n.t('lang_GENERIC_MESSAGE_ERROR_BANK_DATA_TOKEN_COUNT')
        }
        return i18n.t('lang_GENERIC_MESSAGE_ERROR_BANK_DATA_TOKEN_FORMAT')
    }
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)